const PEOPLE = [
	{
		role: "Engenheiro de obra",
		quote: "O Relatório de Obra fica pronto antes de eu sair do canteiro.",
		text: "Cronograma, medições, feed e Relatório de Obra no mesmo lugar. Revisa o que a equipe registrou em vez de redigitar.",
	},
	{
		role: "Encarregado e equipe",
		quote: "Tirei a foto, marquei a etapa, pronto.",
		text: "Posta o relato e bate o ponto pelo celular. Não precisa de treinamento nem de planilha.",
	},
	{
		role: "Diretoria da construtora",
		quote: "Sei quais obras estão atrasadas sem ligar para ninguém.",
		text: "O painel do canteiro reúne todas as obras, com avanço, desvio do planejado e próximas entregas.",
	},
	{
		role: "Cliente",
		quote: "Acompanho a minha obra pelas fotos de cada dia.",
		text: "Vê o feed e a evolução da obra com o acesso que você liberou, e nada além disso.",
	},
];

export function Personas() {
	return (
		<section data-slot="band" id="para-quem">
			<div data-slot="wrap">
				<div data-slot="section-intro">
					<p data-slot="eyebrow">Para quem</p>
					<h2 data-slot="section-title">Cada pessoa vê a obra do seu jeito.</h2>
					<p data-slot="section-lede">
						Você convida cada pessoa para uma obra com uma função. As telas e o
						que ela pode ver mudam conforme essa função.
					</p>
				</div>
				<div data-slot="people">
					{PEOPLE.map((person) => (
						<div key={person.role} data-slot="person">
							<span data-slot="person-role">{person.role}</span>
							<q data-slot="person-quote">{person.quote}</q>
							<p data-slot="person-text">{person.text}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
